/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import LocalDate from '../../domain/type/Date'
import MonthlyReportEvent from '../../event/MonthlyReportEvent'

const MonthlySalesSearchState = Record({
  search_monthly_close_date: LocalDate.today().beginningOfMonth(),
  search_hotel_id: null
})

class MonthlySalesSearchStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new MonthlySalesSearchState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyReportEvent.onEditMonthlySalesSearchCondition:
        return state.set(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new MonthlySalesSearchStore()
